import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-OY-logo_svg__Calque_1",
  viewBox: "0 0 26.15 33.52"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-OY-logo_svg__cls-1{fill:#ac3838}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      d: "m0 0 .57.19.76.44 1.46.7L8.12 4l1.46.7 1.21.63 6.86 3.43 1.21.63 1.08.57 1.02.51 1.33.7 1.14.7.63.51.51.44.57.76.38.63.32.95.13 1.14.13 5.4.06 2.03v1.97l-.25.51-.19.19h-.13l-.25-.38-.51-.57-.38-.51-.44-.44-1.08-.76-1.52-.76-1.27-.51-2.03-.83-1.65-.63-1.46-.7-.95-.57-2.29-1.52-1.02-.76-1.02-.83-.95-.83-.76-.7-.89-.83-.44-.51-.7-.76-1.4-1.78-.63-.95-.83-1.33-.95-1.84-.7-1.71-.51-1.4-.64-2.15L.06.95 0 .12v-.13Z",
      class: "svg-OY-logo_svg__cls-1"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "m17.33 22.34.57.06 1.52.63 1.65.7 1.02.51.7.44.89.76.7.51.51.25.63.13v.19l-.38.25-.89.63-1.59 1.02-1.27.76-1.46.83-1.33.76-1.52.89-1.78 1.02-1.59.83h-.44l-.44-.38-.51-.83v-.95l.19-1.08.32-1.21.44-1.27.38-.89.51-.89.76-1.14.51-.7.76-.83.57-.63.57-.38Z",
      style: {"fill":"#5c5f62"}
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      d: "m24.12 25.83.76.38.63.13v.19l-.38.25-.89.63-.7.44-.06-.19.25-.63.19-.44.13-.7.06-.06Z",
      class: "svg-OY-logo_svg__cls-1"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("path", {
      d: "m24.95 13.39.25.32v.13h-.83l-.06-.25.19-.13.44-.06Z",
      style: {"fill":"#5d5e61"}
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "OY-logo"}) } }